module.exports = __webpack_public_path__ + "img/product_119.43d8740.webp";